import React, { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';
import { SERVICE_OPTIONS, BRAND } from '../mock';
import { useToast } from '../hooks/use-toast';

export default function Contact() {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: '', email: '', company: '', service: '', message: '' });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast({ title: 'Missing fields', description: 'Please fill name, email and message.' });
      return;
    }
    toast({ title: 'Inquiry sent', description: `Thanks ${form.name.split(' ')[0]}, we\u2019ll reply within one working day.` });
    setForm({ name: '', email: '', company: '', service: '', message: '' });
  };

  const on = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <section id="contact" className="py-24 md:py-32">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="eyebrow mono-font text-black/60">Start a Conversation</div>
          <h2 className="display-font mt-8 text-[16vw] md:text-[7rem] leading-[0.9]">
            Let&apos;s <span className="accent-red">build.</span>
          </h2>
          <p className="mt-8 text-black/60 max-w-md">
            Need talent, a team, or a product built? Tell us what you&apos;re working on and we&apos;ll get back within one working day.
          </p>
          <a href={`mailto:${BRAND.email}`} className="inline-flex items-center gap-2 mt-10 display-font text-2xl md:text-3xl text-black hover:text-[#FF5C4D] transition-colors">
            {BRAND.email} <ArrowUpRight className="w-6 h-6" />
          </a>
        </div>

        <form onSubmit={submit} className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-4">
          <input required value={form.name} onChange={on('name')} placeholder="Your name *" className="form-input rounded-lg px-4 py-4 bg-grid" />
          <input required type="email" value={form.email} onChange={on('email')} placeholder="Email *" className="form-input rounded-lg px-4 py-4 bg-grid" />
          <input value={form.company} onChange={on('company')} placeholder="Company" className="form-input rounded-lg px-4 py-4 bg-grid md:col-span-2" />
          <select value={form.service} onChange={on('service')} className="form-input rounded-lg px-4 py-4 bg-grid md:col-span-2 appearance-none">
            <option value="">What do you need?</option>
            {SERVICE_OPTIONS.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
          <textarea required value={form.message} onChange={on('message')} rows={6} placeholder="Tell us about your project *" className="form-input rounded-lg px-4 py-4 bg-grid md:col-span-2 resize-none" />
          <button type="submit" className="btn-primary rounded-lg px-4 py-4 md:col-span-2 font-semibold inline-flex items-center justify-center gap-2">
            Send Inquiry <ArrowUpRight className="w-4 h-4" />
          </button>
        </form>
      </div>
    </section>
  );
}
